import React from 'react';
import { compose, withProps } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import useJoinLeaveButtonProps from './../useJoinLeaveButtonProps';
import style from './index.scss';

export const LeaveButton = ({ t, onClick, disabled, wide = false, shortText = false, useTournament }) => {
    let classes = [style.button];
    if (wide) {
        classes.push(style.wide);
    }
    classes = classes.join(' ');
    return (
        <Button
            view='secondary'
            variant='rounded'
            color='negative'
            size='large'
            onClick={onClick}
            disabled={disabled}
            className={classes}>
            {shortText ? t('playtech.mobile.system.pass-the-parcel.leaveRace.popup.button.leave') :
                useTournament ? t('playtech.mobile.system.pass-the-parcel.button.leaveLeaderboard.tournament') : t('playtech.mobile.system.pass-the-parcel.button.leaveLeaderboard')}
        </Button>
    );
};

export default compose(
    withTranslations,
    withProps(
        ({ leaderboardId, useTournament }) => {
            const { onClick, disabled } = useJoinLeaveButtonProps('leave')({ leaderboardId, useTournament });
            return {
                onClick,
                disabled
            };
        }
    )
)(LeaveButton);
